
import React, {Component} from 'react';
import { connect } from 'react-redux';

const AppRow = (props) => {
    const { app, is_selected } = props;

    let rowClasses = "cursor-pointer text-gray-800 rounded-sm my-4 py-4 px-6 border-solid border-2";
    if (is_selected) {
        rowClasses += " border-blue-500";
    } else {
        rowClasses += " border-white hover:bg-gray-200";
    }

    const buttonLabel = is_selected ? "Remove " + app.name : "Add " + app.name;

    const monthlyPrice = app.monthly_price;
    let priceDisplay = null;
    if (monthlyPrice && monthlyPrice.amount) {
        const dollars = (monthlyPrice.amount / 100).toFixed(2);
        const interval = monthlyPrice.interval || 'month';
        priceDisplay = (
            <p className="text-gray-500 text-sm mt-1">${dollars}/{interval}</p>
        );
    }

    return (
        <div className={rowClasses} onClick={() => props.changeHandler(app)}>
            {app.icon && (
                <div className="float-left w-10 h-10 rounded-sm m-0 overflow-hidden">
                    <img src={app.icon} className="w-full h-full object-cover" />
                </div>
            )}
            <div className={"w-full mt-0 mb-4" + (app.icon ? " ml-10 pl-4" : "")}>
                <p className="text-gray-700 text-xl">{app.name}</p>
                {app.description && <p className="text-gray-500 mt-1">{app.description}</p>}
                {priceDisplay}
            </div>
            <div className="float-none clearfix"></div>
            <div className="p-4 m-0">
                <div className="bg-blue-500 hover:bg-blue-400 cursor-pointer w-full rounded-sm pt-4 pb-4 m-0">
                    <p className="text-white font-bold text-center text-lg">{buttonLabel}</p>
                </div>
            </div>
        </div>
    );
}

class AccountsSignupAppPickerView extends Component {

    appSelectionChange(product) {
        this.props.onAppStateChange(product);
    }

    render() {
        return (
            <div>
                {this.props.available_apps.map((app) => {
                    let matchingApp = this.props.selected_apps.find(sel => sel.id === app.id);
                    let is_selected = matchingApp != null;
                    return <AppRow key={app.id} is_selected={is_selected} app={app} changeHandler={(target) => this.appSelectionChange(target)} />
                })}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {};
}

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsSignupAppPickerView);
